module.exports = __webpack_public_path__ + "img/zhewan7.44be3c4e.jpg";